<template>
    <div class="main-layout-section admin-portal secondary">
        <AdminHeader @setPodData="setPodData($event)" />
        
        <div class="w-logo mb-3">
            <img :src="logo_file" alt="logo" class="w-input-fields animate__animated animate__fadeIn animate__fast" v-if="logo_file !== '' && logo_file !== null"/>
        </div>

        <div class="main-content">
            <h3 class="page-subheading mb-3 animate__animated animate__fadeIn animate__fast">Manage Your Reservations</h3>

            <div class="col-md-11 mx-auto">

                <div class="admin-general-section">

                    <div class="admin-general-section-buttons">
                        <router-link to="/admin/dashboard" class="admin-general-section-button">
                            Back To Dashboard
                        </router-link>
                        <router-link :to="`/admin/reservations/create`" class="admin-general-section-button">
                            Create a Single Reservation
                        </router-link>
                        <router-link :to="`/admin/reservations/recurring`" class="admin-general-section-button">
                            Create a Recurring Reservation
                        </router-link>
                    </div>

                    <template v-if="loggedin_role !== 6">
                        <h3 class="page-subheading mt-3 text-left">Number of Minutes Reservation is Held Past Start Time Without Check In</h3>
                        <div class="row m-0 p-0 col-md-12 col-sm-12 m-auto mb-3">
                            <b-form inline @submit.stop.prevent class="m-0 p-0">
                                <div class="row mt-1">
                                    <div class="d-flex mb-1 col-md-3 flex-column">
                                        <div class="w-form-control w-input-fields w-100" :class="{ 'is_invalid': $v.minutes_form.reservation_minutes.$error }">
                                            <span><i class="fa-solid fa-clock"></i></span>
                                            <b-form-input
                                                v-model="minutes_form.reservation_minutes"
                                                id="minutes-name"
                                                class="mb-2 mr-sm-2 mb-sm-0 user-name bg-lightBlack border-0"
                                                :class="{ 'is-invalid': $v.minutes_form.reservation_minutes.$error }" 
                                                @keypress="onlyNumbers"
                                            ></b-form-input>
                                        </div>
                                    </div>
                                    
                                    <div class="d-flex mb-1 col-md-1 flex-column w-auto">
                                        <div class="w-form-control m-0 p-0">
                                            <a
                                            href="javascript:void(0)" 
                                            class="flex-fill m-0" 
                                            v-if="!minutes_status" 
                                            @click="handleMinutesForm"
                                            >
                                            <b-icon class="icon" icon="save"></b-icon> 
                                            Save
                                            </a>
                                            <a
                                            href="javascript:void(0)" 
                                            class="flex-fill m-0" 
                                            v-if="minutes_status"
                                            >
                                            <b-icon class="icon" icon="arrow-clockwise" animation="spin"></b-icon> 
                                            Saving minutes...
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </b-form>
                        </div>
                    </template>

                    <!-- start today reservations section -->
                    <h3 class="page-heading mb-3 mt-3 text-left">Happening Today</h3>
                    <div class="col-sm-12">
                        <div class="overflow-auto p-0 m-0">
                            <b-table
                            id="admin-general-table"
                            :striped="true"
                            :hover="false"
                            :dark="false"
                            :items="reservations_today"
                            :fields="fields_today"
                            show-empty
                            :emptyText="emptyText"
                            >
                                <template #cell(emails_list)="data">
                                    <div class="three-line-wrap three-line-wrap-300">
                                        {{ data.item.emails_list }}
                                    </div>
                                </template>
                                <template #cell(pod_navs)="data">
                                    <div class="three-line-wrap three-line-wrap-200">
                                        {{ data.item.pod_navs }}
                                    </div>
                                </template>
                                <template #cell(start_time)="data">
                                    {{ data.item.reservation_start.time }}
                                </template>
                                <template #cell(stop_time)="data">
                                    {{ data.item.reservation_end.time }}
                                </template>
                                <template #cell(action)="data">
                                    <div class="icon-action-buttons-container d-flex flex-row">

                                        <!-- edit button -->
                                        <router-link :to="`/admin/reservations/edit/${data.item.id}`" :class="data.value" class="btn-sm">
                                            <b-icon class="icon" icon="pencil-fill"></b-icon>
                                            View Details
                                        </router-link>
                                    </div>
                                </template>
                                <template #cell(checkin)="data">
                                    <div class="icon-action-buttons-container d-flex flex-row">

                                        <!-- edit button -->
                                        <button class="btn-sm" :class="data.value" @click="confirmCheckin(data.item.id)">
                                            <b-icon class="icon" icon="person-check-fill"></b-icon>
                                            {{ checkin_status ? 'Checking-In...' : 'Check-In' }}
                                        </button>
                                    </div>
                                </template>
                                <template #empty="scope">
                                    <p class="text-center p-0 m-0">{{ scope.emptyText }}</p>
                                </template>
                            </b-table>
                        </div>
                        <b-pagination
                        v-model="current_page_today"
                        :total-rows="total_rows_today"
                        :per-page="per_page_today" 
                        limit="3"
                        aria-controls="admin-general-table" 
                        :disabled="api_state_today"
                        align="right"
                        ></b-pagination>
                        <p class="admin-general-table-status-text">{{ status_text_today }}</p>
                    </div>
                    <!-- end today reservations section -->

                    <!-- start recurring reservations section -->
                    <h3 class="page-heading mb-3 mt-3 text-left">Recurring Reservations</h3>
                    <div class="col-sm-12">
                        <div class="overflow-auto p-0 m-0">
                            <b-table
                            id="admin-general-table"
                            :striped="true"
                            :hover="false"
                            :dark="false"
                            :items="reservations_recurring"
                            :fields="fields_recurring"
                            show-empty
                            :emptyText="emptyTextRecurring"
                            >
                                <template #cell(emails_list)="data">
                                    <div class="three-line-wrap three-line-wrap-300">
                                        {{ data.item.emails_list }}
                                    </div>
                                </template>
                                <template #cell(pod_navs)="data">
                                    <div class="three-line-wrap three-line-wrap-200">
                                        {{ data.item.pod_navs }}
                                    </div>
                                </template>
                                <template #cell(date)="data">
                                    <div v-html="data.item.dates.join(',')"></div>
                                </template>
                                <template #cell(start_time)="data">
                                    <div v-html="data.item.start_times[0]"></div>
                                </template>
                                <template #cell(stop_time)="data">
                                    <div v-html="data.item.stop_times[0]"></div>
                                </template>
                                <template #cell(action)="data">
                                    <div class="icon-action-buttons-container d-flex flex-row">

                                        <!-- edit button -->
                                        <router-link :to="`/admin/reservations/recurring_edit/${data.item.id}`" :class="data.value" class="btn-sm">
                                            <b-icon class="icon" icon="pencil-fill"></b-icon>
                                            View Details
                                        </router-link>
                                    </div>
                                </template>
                                <template #empty="scope">
                                    <p class="text-center p-0 m-0">{{ scope.emptyTextRecurring }}</p>
                                </template>
                            </b-table>
                        </div>
                        <b-pagination
                        v-model="current_page_recurring"
                        :total-rows="total_rows_recurring"
                        :per-page="per_page_recurring" 
                        limit="3"
                        aria-controls="admin-general-table" 
                        :disabled="api_state_recurring"
                        align="right"
                        ></b-pagination>
                        <p class="admin-general-table-status-text">{{ status_text_recurring }}</p>
                    </div>
                    <!-- end today reservations section -->

                    <!-- start all reservations section -->
                     <div class="header-container">
                        <h3 class="page-heading mb-3 mt-3 text-left">All Reservations</h3>
                        <div class="w-form-control w-input-fields table-search-input">
                            <span><i class="fa-solid fa-user"></i></span>
                            <b-form-select
                                v-model="selected_lab_id"
                                :options="labs"
                                text-field="value"
                                value-field="id"
                                id="selected_lab_id"
                                class=""
                                placeholder="Select a lab" 
                                @change="loadEventsByLab" 
                                :disabled="calendar_api_state"
                            ></b-form-select>
                        </div>
                    </div>
                    <div class="col-md-12 mx-auto calendar-wrapper mb-4">
                            <FullCalendar 
                                ref="fullCalendar"
                                :options="calendarOptions"
                            />
                    </div>
                    <div class="col-sm-12">
                        <div class="overflow-auto p-0 m-0">
                            <b-table
                            id="admin-general-table"
                            :striped="true"
                            :hover="false"
                            :dark="false"
                            :items="reservations"
                            :fields="fields"
                            show-empty
                            :emptyText="emptyText"
                            >
                                <template #cell(emails_list)="data">
                                    <div class="three-line-wrap three-line-wrap-300">
                                        {{ data.item.emails_list }}
                                    </div>
                                </template>
                                <template #cell(pod_navs)="data">
                                    <div class="three-line-wrap three-line-wrap-200">
                                        {{ data.item.pod_navs }}
                                    </div>
                                </template>
                                <template #cell(date)="data">
                                    {{ data.item.reservation_start.date }}
                                </template>
                                <template #cell(start_time)="data">
                                    {{ data.item.reservation_start.time }}
                                </template>
                                <template #cell(stop_time)="data">
                                    {{ data.item.reservation_end.time }}
                                </template>
                                <template #cell(action)="data">
                                    <div class="icon-action-buttons-container d-flex flex-row">

                                        <!-- edit button -->
                                        <router-link :to="`/admin/reservations/edit/${data.item.id}`" :class="data.value" class="btn-sm">
                                            <b-icon class="icon" icon="pencil-fill"></b-icon>
                                            View Details
                                        </router-link>
                                    </div>
                                </template>
                                <template #empty="scope">
                                    <p class="text-center p-0 m-0">{{ scope.emptyText }}</p>
                                </template>
                            </b-table>
                        </div>
                        <b-pagination
                        v-model="current_page"
                        :total-rows="total_rows"
                        :per-page="per_page" 
                        limit="3"
                        aria-controls="admin-general-table" 
                        :disabled="api_state"
                        align="right"
                        ></b-pagination>
                        <p class="admin-general-table-status-text">{{ status_text }}</p>
                    </div>
                    <!-- end all reservations section -->

                </div>

            </div>

        </div>

        <!-- start of footer section -->
        <div class="col-md-12 mx-auto">
            <AdminFooter type="inner" />
        </div>
        <!-- end of footer section -->

        <!-- start of checkin confirm modal -->
        <b-modal id="checkin-modal" dialog-class="admin-portal-modal" header-class="admin-portal-bg secondary px-3 py-2" hide-footer>
            <template #modal-title>
                Confirm
                <b-icon 
                class="icon" 
                icon="question-circle-fill"
                >
                </b-icon> 
            </template>
            <b-overlay :show="false" rounded="lg">
                <div class="d-flex">
                <p>Are you sure you want to check-in this Reservation?</p>
                </div>
                <div class="d-flex text-center">
                <button
                    type="button"
                    class="modal-button px-5 py-2"
                    @click="checkinReservation"
                >
                    Yes
                </button>
                <button
                    type="button"
                    class="modal-button px-5 py-2 mx-2"
                    @click="$bvModal.hide('checkin-modal')"
                >
                    No
                </button>
                </div>
            </b-overlay>
        </b-modal>

    </div>
</template>

<script>
import AdminHeader from "@/views/admin/AdminHeader.vue";
import { adminGetReservationsList, adminReservationMinutes, adminGetRecurringReservationsList, adminGetReservationsListForCalendar, adminGetLabsList, adminCheckinReservation } from "../../services/AdminService";
import AdminFooter from "@/views/admin/AdminFooter.vue";
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
    name: "AdminReservations-view",
    components: { AdminHeader, AdminFooter, FullCalendar },
    data() {
        return {
            emptyText:"No reservations found at the moment!",
            emptyHtml:"No reservations found at the moment!",
            fields: [
                {'key' : 'action', 'label' : 'Action'},
                {'key' : 'linkedlab.lab_name', 'label' : 'Lab'},
                {'key' : 'group_name', 'label' : 'Group Name'},
                {'key' : 'passcode', 'label' : 'Passcode'},
                {'key' : 'date', 'label' : 'Date'},
                {'key' : 'start_time', 'label' : 'Start Time'}, 
                {'key' : 'stop_time', 'label' : 'Stop Time'},
                {'key' : 'status', 'label' : 'Status'},
                {'key' : 'pod_navs', 'label' : 'Navs'}, 
                {'key' : 'emails_list', 'label' : 'List of Authorized User Accounts'}
            ],
            reservations: [],
            status_text: '',
            per_page: 20,
            current_page: 1,
            total_rows: 0,
            minutes_form: {
                reservation_minutes : 0
            },
            minutes_status: false,
            api_state: false,
            reservations_today: [],
            status_text_today: '',
            per_page_today: 20,
            current_page_today: 1,
            total_rows_today: 0,
            api_state_today: false,
            user_timezone: moment.tz.guess(),
            emptyTextRecurring:"No recurring reservations found at the moment!",
            emptyHtmlRecurring:"No recurring reservations found at the moment!",
            fields_recurring: [
                {'key' : 'action', 'label' : 'Action'},
                {'key' : 'linkedlab.lab_name', 'label' : 'Lab'},
                {'key' : 'group_name', 'label' : 'Group Name'},
                {'key' : 'passcode', 'label' : 'Passcode'},
                {'key' : 'start_time', 'label' : 'Start Time'}, 
                {'key' : 'stop_time', 'label' : 'Stop Time'},
                {'key' : 'date', 'label' : 'Dates'},
                {'key' : 'pod_navs', 'label' : 'Navs'}, 
                {'key' : 'emails_list', 'label' : 'List of Authorized User Accounts'}
            ],
            fields_today: [
                {'key' : 'action', 'label' : 'Action'},
                {'key' : 'checkin', 'label' : 'Check-In'},
                {'key' : 'linkedlab.lab_name', 'label' : 'Lab'},
                {'key' : 'group_name', 'label' : 'Group Name'},
                {'key' : 'passcode', 'label' : 'Passcode'},
                {'key' : 'start_time', 'label' : 'Start Time'}, 
                {'key' : 'stop_time', 'label' : 'Stop Time'},
                {'key' : 'status', 'label' : 'Status'},
                {'key' : 'pod_navs', 'label' : 'Navs'}, 
                {'key' : 'emails_list', 'label' : 'List of Authorized User Accounts'}
            ],
            reservations_recurring: [],
            status_text_recurring: '',
            per_page_recurring: 20,
            current_page_recurring: 1,
            total_rows_recurring: 0,
            api_state_recurring: false,

            // calendar variables
            currentMonthEvents: [],
            currentSchedules: [],
            calendarOptions: {
                plugins: [dayGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',   // IMPORTANT (must NOT be empty)
                selectable: false,
                events: [],
                datesSet: this.handleDatesSet,
                dayMaxEvents: 4,
                dayMaxEventRows: true,
                expandRows: false,
                moreLinkClick: 'popover',
                eventDisplay: 'block',
                eventDidMount(info) {
                    info.el.setAttribute(
                        'title',
                        info.event.title
                    )
                },
                eventContent: function(arg) {
                    // Use default rendering for all-day events
                    if (arg.event.allDay) {
                        return true;
                    }

                    let start = arg.event.start;
                    let end = arg.event.end;
                    let startTime = start
                    ? start.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                    : '';

                    let endTime = end
                    ? end.toLocaleTimeString([], {
                        hour: '2-digit',
                        minute: '2-digit'
                    })
                    : '';
                    return {
                        html: `
                        <div class="fc-event-title-custom">
                            <div class="fc-event-title-line">
                                ${arg.event.title}
                            </div>

                            <div class="fc-event-time-line">
                                ${startTime} - ${endTime}
                            </div>
                        </div>`
                    };
                },
                eventClick: (info) => {
                    info.jsEvent.preventDefault();
                    const props = info.event.extendedProps;
                    
                    // redirect as per type
                    if(props.res_type == 'recurring') {
                        this.$router.push("/admin/reservations/recurring_edit/" + props.res_id);
                    }
                    else {
                        this.$router.push("/admin/reservations/edit/" + props.res_id);
                    }
                }
            },
            calendar_api_state: false,
            calender_api_request: null,
            currentCalendarRange: {
                start: null,
                end: null
            },
            labs: [],
            selected_lab_id: "",
            checkin_status: false,
            checkin_reservation_id: "",
            loggedin_data: [],
            loggedin_role: "",
        };
    },

    validations: {
        minutes_form : {
            reservation_minutes : {required}
        },
    },

    computed: {
        logo_file() {
            return this.$store.getters.getThemeLogo().logo;
        }
    },

    watch: {
        current_page: {
            handler: function(value) {
                if(!this.api_state) {
                    this.current_page = value;
                    this.reservationsList();
                }
            }
        },
        current_page_today: {
            handler: function(value) {
                if(!this.api_state_today) {
                    this.current_page_today = value;
                    this.reservationsListToday();
                }
            }
        },
        current_page_recurring: {
            handler: function(value) {
                if(!this.api_state_recurring) {
                    this.current_page_recurring = value;
                    this.reservationsListRecurring();
                }
            }
        }
    },

    methods: {
        reservationsList() {
            if(this.api_state) {
                return;
            }
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                length: this.per_page,
                page: this.current_page,
            };
            this.api_state = true;
            adminGetReservationsList(params).then(response => {
                this.api_state = false;
                this.reservations = response.data.reservations;
                this.current_page = response.data.current_page;
                this.total_rows = response.data.total_rows;
                this.status_text = response.data.status_text;
                if(this.reservations.length > 0) {
                    this.reservations.map(function(lb){
                        return lb.action='icon-button-actions';
                    });
                }

                // pin the reservation minutes
                this.minutes_form.reservation_minutes = response.data.reservation_minutes;
            });
        },

        makeToast(variant = "default", message) {
            this.$root.$emit("toast_message", {'type' : variant, 'message' : message});
        },

        setPodData(obj) {
            this[obj.key] = obj.value;
        },

        handleMinutesForm() {
            if(this.minutes_status) {
                return;
            }

            this.$v.minutes_form.$touch();
            if (this.$v.minutes_form.$invalid) {
                this.makeToast("error", "generic-required-message");
            } 
            else {
                let user_data = JSON.parse(localStorage.user_sess_data);
                let data = this.minutes_form;
                data.token = user_data.token;
                data.client_id = user_data.client_id;

                this.minutes_status = true;
                adminReservationMinutes(data).then(response => {
                    this.minutes_status = false;
                    if(response.status) {
                        this.makeToast("success", response.message);
                        this.minutes_form.reservation_minutes = response.data.reservation_minutes;
                    }
                    else {
                        this.makeToast("error", response.message);
                    }
                });
            }
        },
        onlyNumbers(event) {
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
        },

        reservationsListToday() {
            if(this.api_state_today) {
                return;
            }
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                length: this.per_page_today,
                page: this.current_page_today,
                req_mode: "today",
                req_tz: this.user_timezone
            };
            this.api_state_today = true;
            adminGetReservationsList(params).then(response => {
                this.api_state_today = false;
                this.reservations_today = response.data.reservations;
                this.current_page_today = response.data.current_page;
                this.total_rows_today = response.data.total_rows;
                this.status_text_today = response.data.status_text;
                if(this.reservations_today.length > 0) {
                    this.reservations_today.map(function(lb){
                        return lb.action='icon-button-actions';
                    });
                }

                // pin the reservation minutes
                this.minutes_form.reservation_minutes = response.data.reservation_minutes;
            });
        },

        reservationsListRecurring() {
            if(this.api_state_recurring) {
                return;
            }
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                length: this.per_page_recurring,
                page: this.current_page_recurring,
                req_tz: this.user_timezone
            };
            this.api_state_recurring = true;
            adminGetRecurringReservationsList(params).then(response => {
                this.api_state_recurring = false;
                this.reservations_recurring = response.data.reservations;
                this.current_page_recurring = response.data.current_page;
                this.total_rows_recurring = response.data.total_rows;
                this.status_text_recurring = response.data.status_text;
                if(this.reservations_recurring.length > 0) {
                    this.reservations_recurring = response.data.reservations.map(item => {
                        return {
                            ...item,
                            dates: item.schedules.map(s => s.sch_start.date),
                            start_times: item.schedules.map(s => s.sch_start.time),
                            stop_times: item.schedules.map(s => s.sch_end.time)
                        };
                    });
                }
            });
        },
        labsList() {
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id
            };
            adminGetLabsList(params).then(response => {
                this.labs = response.data.labs;
                if(this.labs.length == 1) {
                    this.selected_lab_id = this.labs[0].id;
                }
                // add empty option as placeholder
                this.labs.splice(0, 0, {'id' : '', 'value' : 'Select a lab'});
                // get events list
                this.fetchEventsList();
            });
        },
        datesSet(info) {
            this.currentCalendarRange = {
                start: info.startStr,
                end: info.endStr
            }
            this.fetchEventsList();
        },
        handleDatesSet(info) {
            this.currentCalendarRange = {
                start: info.startStr,
                end: info.endStr
            }
            this.fetchEventsList();
        },
        async fetchEventsList() {
            if(!this.currentCalendarRange.start) {
                return;
            }
            if(this.calender_api_request) {
                this.calender_api_request.abort();
                this.calender_api_request = null;
            }
            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                client_id: user_data.client_id,
                lab_id: this.selected_lab_id,
                start: this.currentCalendarRange.start,
                end: this.currentCalendarRange.end
            };

            this.calender_api_request = new AbortController();
            this.calendar_api_state = true;
            const response = await adminGetReservationsListForCalendar(
                params,
                this.calender_api_request.signal
            );
            this.calendar_api_state = false;
            this.currentMonthEvents = response.data.reservations;
            this.syncEvents();
        },
        syncEvents() {
            const db_events = this.currentMonthEvents || [];
            this.calendarOptions = {
                ...this.calendarOptions,
                events: [
                    ...db_events
                ]
            }
        },
        loadEventsByLab() {
            this.fetchEventsList();
        },
        confirmCheckin(res_id) {
            this.$bvModal.show('checkin-modal');
            this.checkin_reservation_id = res_id;
        },
        checkinReservation() {
            if(this.checkin_status) {
                return;
            }

            let user_data = JSON.parse(localStorage.user_sess_data);
            let params = {
                token: user_data.token,
                reservation_id: this.checkin_reservation_id
            };
            this.checkin_status = true;
            this.$bvModal.hide('checkin-modal');
            adminCheckinReservation(params).then(response => {
                this.checkin_status = false;
                if(response.status) {
                    this.makeToast("success", response.message);
                    this.reservationsListToday();
                }
                else {
                    this.makeToast("error", response.message);
                }
            });
        },
    },

    mounted() {
        this.reservationsList();
        this.reservationsListToday();
        this.reservationsListRecurring();
        this.labsList();
        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if(modalId == "checkin-modal") {
                this.checkin_reservation_id = "";
            }
        });
    },
    created () {
        // set loggedin data
        if(typeof localStorage.user_sess_data !== 'undefined') {
            this.loggedin_data = JSON.parse(localStorage.user_sess_data);
            this.loggedin_role = this.loggedin_data.role_id;
        }
    }
};
</script>
<style scoped>
.admin-portal #admin-general-table {
    user-select: text !important;
}
.admin-portal #admin-general-table .pod-key-container {
    display: flex;
    flex-direction: row;
    column-gap: 20px;
    align-items: center;
}
.admin-portal #admin-general-table .three-line-wrap-300 {
    width: 300px;
}
.admin-portal #admin-general-table .three-line-wrap-200 {
    width: 200px;
}
.admin-portal #admin-general-table .three-line-wrap {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
}
.header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
@media screen and (max-width: 512px) {
    .header-container {
        flex-direction: column;
    }
}
/* calendar styles */
:deep(.fc-toolbar) {
  color: #d8d8d8;
  font-family: sans-serif;
}
:deep(.fc .fc-toolbar-title) {
    font-size: 1.50em;
    margin: 0px;
    font-family: sans-serif;
    font-weight: 600;
}
:deep(.fc .fc-today-button) {
    text-transform: capitalize;
    font-family: sans-serif;
    background-color: transparent;
    border: 2px solid #7f7f7f;
}
:deep(.fc .fc-today-button:hover) {
    background-color: var(--client-primary);
    border: 2px solid var(--client-primary);
}
:deep(.fc .fc-prev-button),
:deep(.fc .fc-next-button) {
    background-color: transparent;
    border: 2px solid #7f7f7f;
    color: #d8d8d8;
}
:deep(.fc .fc-prev-button) {
    border-right: 0;
}
:deep(.fc .fc-prev-button:hover),
:deep(.fc .fc-next-button:hover) {
    background-color: var(--client-primary);
    border-color: var(--client-primary);
}
:deep(.fc-col-header) {
    background-color: #7f7f7f;
}
:deep(.fc-col-header .fc-col-header-cell) {
    padding: 0.5em;
}
:deep(.fc-col-header .fc-col-header-cell a) {
    color: #191919;
    text-decoration: none;
}
:deep(.fc-daygrid-body .fc-daygrid-day a) {
    color: #d8d8d8;
    text-decoration: none;
    font-weight: 600;
}
:deep(.fc-theme-standard .fc-scrollgrid) {
    border-color: #d8d8d8;
}
:deep(.fc-theme-standard td), 
:deep(.fc-theme-standard th) {
    border-color: #d8d8d8;
}
:deep(.fc .fc-daygrid-day.fc-day-today) {
    background-color: #19191970;
    opacity: 1;
}
:deep(.fc .fc-daygrid-day.fc-day-today a) {
    color: #d8d8d8;
}
:deep(.fc .fc-daygrid-day .selected-date) {
    background-color: var(--client-primary);
    color: #d8d8d8;
    opacity: 1;
}
:deep(.fc-daygrid-event) {
  border-radius: 6px;
  padding: 2px 6px;
}
:deep(.fc-event-title) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d8d8d8;
}
:deep(.fc-event-title-custom) {
  overflow: hidden;
  width: 100%;
}
:deep(.fc-event-title-line) {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d8d8d8;
  font-weight: 600;
  font-size: 12px;
  display: block;
}
:deep(.fc-event-time-line) {
  font-size: 11px;
  white-space: nowrap;
}
:deep(.fc-h-event) {
    background-color: transparent;
    border: 1px solid var(--client-primary);
    display: block;
}
:deep(.fc-h-event .fc-event-time) {
    overflow: visible;
}
:deep(.fc-theme-standard .fc-popover) {
    background: #d8d8d8;
    border-color: var(--client-primary);
}
:deep(.fc-theme-standard .fc-popover-header) {
    background: var(--client-primary);
    color: #fff;
}
:deep(.fc-popover-body .fc-h-event) {
    background: var(--client-primary);
}
/* end of calendar styles  */
</style>